<template>
  <div :class="`d-flex justify-space-between ga-5 ${xs ? 'flex-column' : ''}`">
    <y-btn-nd
      class="form-disable-enter px-16"
      :style="!previousLabel ? 'visibility: hidden;' : ''"
      :block="xs"
      :text="previousLabel"
      @click="handlePreviousClick"
    />
    <div
      v-if="!noNextButton"
      :class="`d-flex ${xs ? '' : 'flex-row-reverse'} flex-wrap align-center justify-end`"
    >
      <y-btn
        :disabled="disabled"
        :loading="nextLoading"
        class="px-16"
        :block="xs"
        :text="nextLabel || t('form.next')"
        @click="handleNextClick"
      />
      <label v-if="!disabled && enterSubmitEnabled" class="mx-2 text-grey">{{
        t(`form.orEnter${xs ? "Suffix" : "Prefix"}`)
      }}</label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useDisplay } from "vuetify";

const { t } = useI18n();
const { xs } = useDisplay();

const disabled = defineModel("disabled", { type: Boolean, required: false, default: false });

defineProps({
  nextLabel: {
    type: String,
    required: false,
    default: undefined,
  },
  nextLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  previousLabel: {
    type: String,
    required: false,
    default: undefined,
  },
  enterSubmitEnabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  noNextButton: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(["nextClick", "previousClick"]);

const handleNextClick = () => {
  emit("nextClick");
};

const handlePreviousClick = () => {
  emit("previousClick");
};
</script>
